/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PassengerSeat
 */
export interface PassengerSeat {
    /**
     * The first name of the passenger
     * @type {string}
     * @memberof PassengerSeat
     */
    firstName?: string;
    /**
     * The last name of the passenger
     * @type {string}
     * @memberof PassengerSeat
     */
    lastName?: string;
    /**
     * The seat number of the passenger
     * @type {string}
     * @memberof PassengerSeat
     */
    seat?: string;
}

/**
 * Check if a given object implements the PassengerSeat interface.
 */
export function instanceOfPassengerSeat(value: object): value is PassengerSeat {
    return true;
}

export function PassengerSeatFromJSON(json: any): PassengerSeat {
    return PassengerSeatFromJSONTyped(json, false);
}

export function PassengerSeatFromJSONTyped(json: any, ignoreDiscriminator: boolean): PassengerSeat {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'seat': json['seat'] == null ? undefined : json['seat'],
    };
}

export function PassengerSeatToJSON(json: any): PassengerSeat {
    return PassengerSeatToJSONTyped(json, false);
}

export function PassengerSeatToJSONTyped(value?: PassengerSeat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'seat': value['seat'],
    };
}

